module.exports = __webpack_public_path__ + "img/ring_y_o_1_1@2x.a55e2ce7.png";